import o from"./symbol-constructor-detection.js";var r=o,t=r&&!!Symbol.for&&!!Symbol.keyFor;export{t as default};
